import { ValidationSubmissionDocument } from '@percent/admin-dashboard/api/types'

export const mockValidationSubmissionDocument: ValidationSubmissionDocument = {
  id: 'staging_validationsubmissiondocument_000000Ci1QHjCrWaoQeYlcLvyzRVQ.pdf',
  validationInviteId: 'staging_validationinvite_154beeb1-8b08-44c1-9c25-19f1e47c20fa',
  createdAt: '2023-10-09T12:41:26.609Z',
  url: 'https://s3.eu-west-1.amazonaws.com/staging-static.poweredbypercent.com/validationsubmissiondocument/staging_validationsubmissiondocument_000000Ci2QHjCrWmoQeYlcLvyzRVQ.pdf',
  validationSubmissionId: 'staging_validationsubmission_000000Ci2QHwuiEUJ1wbTFPPis6xE',
  documentMatchingResults: {
    roleCategories: ['teaching', 'students'],
    roleCategoryOutcome: 'rejected',
    nameMatchCategory: 'full_match',
    nameMatchOutcome: 'accepted'
  }
}
